import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getUserDeviceActivities } from '../../../store/actions';
import { buildPaginationData } from '../../../utility/utils';
import { Card, CardContent } from "../../ui/card";
import UserDeviceTable from "../../tables/UserDeviceTable";
import OptionalPagination from '../../pagination/OptionalPagination';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell
} from "../../ui/table";

const Applications = ({ userId, history }) => {
  const dispatch = useDispatch();
  const [ paginationData, setPaginationData ] = useState(null);
  const { deviceActivities, loading } = useSelector((state) => state.Device);
  const { data: testDetailsData } = useSelector((state) => state.TestDetails);
  const { device } = useSelector(state => state.UserStatus);
  const [ sortBy, setSortBy ] = useState(null);

  const fetchData = (page) => {
    let queryParams = { id: userId };

    if (page) {
      queryParams.page = page;
    }

    if (sortBy) {
      queryParams.sort_by = sortBy;
    }

    if (testDetailsData?.guid) {
      const myFilter = {search_by: 'guid', keyword: testDetailsData?.guid};
      queryParams = {...queryParams, ...myFilter};
    }

    dispatch(getUserDeviceActivities(history, queryParams));
  };

  const onTableSortChange = (sortBy) => {
    if (sortBy) {
      setSortBy(sortBy);
      fetchData();
    }
  };

  const navigateToPage = (page) => {
    fetchData(page);
  };

  useEffect(() => {
    if (userId && !deviceActivities?.device_activities?.length) {
      dispatch(getUserDeviceActivities(history, { id: userId }));
    }
  }, [userId]);

  useEffect(() => {
    if (deviceActivities?.device_activities?.length > 0) {
      setPaginationData(buildPaginationData(deviceActivities));
    }
  }, [deviceActivities]);

  return (
    <Card>
      <CardContent className="pt-6">
        {device?.userDevices?.length > 0 && (<div>
          <h4 className="text-sm font-semibold mb-2">
            Most Recent Devices
          </h4>
          <Table className="mb-3">
            <TableHeader>
              <TableRow>
                <TableHead>Google Device Id</TableHead>
                <TableHead>Last Updated At</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {device?.userDevices?.map((device, idx) => (
                <TableRow key={idx}>
                  <TableCell>{device.deviceId}</TableCell>
                  <TableCell>{device.lastUpdated}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>)}
        <div className="mb-4 flex justify-between items-center">
          <h3 className="font-semibold text-lg">
            Log Entries
          </h3>
        </div>
        <div className="overflow-x-auto">
          <UserDeviceTable
            fetch={fetchData}
            data={deviceActivities?.device_activities}
            isLoading={loading}
            onSortChange={onTableSortChange}
            disableSortBy
          />
          <OptionalPagination
            items={deviceActivities?.device_activities}
            paginationData={paginationData}
            navigateTo={navigateToPage}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default Applications;
